import { defaultListParams } from "../../../../common/filterTable/constants/defaultListParams";
import { cleanParams } from '../../../../common/filterTable/helpers/cleanParams';
import { FilterFields } from '../types/FilterFields';
import { GetListParams } from '../types/GetListParams';

const useGetListParams = () => {
    const getListParams = (fields: FilterFields) => {
        const { createdDateFrom, 
                createdDateTo, 
                programName, 
                cardProfileName, 
                orderId, 
                pfhNumber, 
                originalCardNumber, 
                cardNumber, 
                panLast4, 
                status, 
                reissueOrderId, 
                e6CardStatus, 
                distributorAgentId, 
                lastModifiedTimeFrom, 
                lastModifiedTimeTo 
            } = fields;
    
        const params: GetListParams = {
            ...defaultListParams,
            creationTimeFrom: createdDateFrom,
            creationTimeTo: createdDateTo,
            lastModifiedTimeFrom,
            lastModifiedTimeTo,
            programName,
            cardProfileName,
            orderId,
            customerNumber: pfhNumber,
            originalCardNumber,
            cardNumber,
            panLast4,
            status,
            reissueOrderId,
            e6CardStatus,
            distributorAgentId,
        };
    
        return cleanParams(params);
    };
    
    return {
        getListParams,
    };
}

export default useGetListParams;